import { useEffect } from 'react';

import { enrollInOptimizeExperiment } from '../utils/optimizeExperiments';

export const useOptimizeExperiment = ({
    experimentName,
    defaultVariation,
    setVariantEnrollment,
}) => {
    useEffect(() => {
        enrollInOptimizeExperiment({
            experimentName,
            defaultVariation,
            setVariantEnrollment,
        });
    }, []);
};
